import { 
  faArrowRight, 
  faChartLine, 
  faCloud, 
  faLaptopCode, 
  faRobot, 
  faServer, 
  faMobileAlt, 
  faDatabase, 
  faShieldAlt, 
  faCode, 
  faGlobe, 
  faProjectDiagram, 
  faToolbox, 
  faUsers,
  faBolt,
  faChartBar,
  faSun,
  faIndustry,
  faCogs
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { Button, Container } from 'reactstrap'

function Servciepage() {
  const [showAllServices, setShowAllServices] = useState(false);

  // Enhanced services array with nested services
  const services = [
    {
      category: "Software Development",
      icon: faLaptopCode,
      path: "/services/software-development",
      description: "Custom web applications, mobile apps, and enterprise software solutions tailored to your specific needs.",
      services: [
        {
          id: "web-development",
          name: "Web Development",
          icon: faGlobe,
          shortDescription: "Custom websites and web applications designed for performance and user experience."
        },
        {
          id: "mobile-development",
          name: "Mobile App Development",
          icon: faMobileAlt,
          shortDescription: "Native and cross-platform mobile applications for iOS and Android."
        },
        {
          id: "custom-software",
          name: "Custom Software",
          icon: faCode,
          shortDescription: "Bespoke software solutions addressing your unique business challenges."
        }
      ]
    },
    {
      category: "Emerging Technologies",
      icon: faRobot,
      path: "/services/emerging-technologies",
      description: "AI/ML solutions, blockchain development, IoT applications, and LLM implementations.",
      services: [
        {
          id: "ai-ml",
          name: "AI & Machine Learning",
          icon: faRobot,
          shortDescription: "Intelligent systems that learn and improve over time."
        },
        {
          id: "blockchain",
          name: "Blockchain Development",
          icon: faDatabase,
          shortDescription: "Secure, transparent applications using distributed ledger technology."
        },
        {
          id: "iot",
          name: "IoT Solutions",
          icon: faProjectDiagram,
          shortDescription: "Connected device ecosystems for data collection and control."
        }
      ]
    },
    {
      category: "Cloud & Infrastructure",
      icon: faCloud,
      path: "/services/cloud-infrastructure",
      description: "Cloud migration, DevOps services, infrastructure optimization, and cybersecurity solutions.",
      services: [
        {
          id: "cloud-migration",
          name: "Cloud Migration",
          icon: faCloud,
          shortDescription: "Seamless transition of your systems and data to cloud environments."
        },
        {
          id: "devops",
          name: "DevOps Services",
          icon: faServer,
          shortDescription: "Streamline your development and operations with automated pipelines."
        },
        {
          id: "cybersecurity",
          name: "Cybersecurity",
          icon: faShieldAlt,
          shortDescription: "Comprehensive security solutions to protect your digital assets."
        }
      ]
    },
    {
      category: "Consulting Services",
      icon: faChartLine,
      path: "/services/consulting",
      description: "Digital transformation, technology strategy, technical audits, and product roadmapping.",
      services: [
        {
          id: "digital-transformation",
          name: "Digital Transformation",
          icon: faChartLine,
          shortDescription: "Comprehensive strategies to modernize your business operations."
        },
        {
          id: "technical-audit",
          name: "Technical Audits",
          icon: faToolbox,
          shortDescription: "In-depth analysis of your current systems with actionable recommendations."
        },
        {
          id: "team-augmentation",
          name: "Team Augmentation",
          icon: faUsers,
          shortDescription: "Skilled professionals to supplement your existing team capabilities."
        }
      ]
    }
  ];

  const additionalServices = [
    {
      category: "Energy Solutions",
      icon: faBolt,
      path: "/services/energy-solutions",
      description: "Innovative technology solutions for the energy sector.",
      services: [
        {
          id: "smart-grid",
          name: "Smart Grid Technology",
          icon: faBolt,
          shortDescription: "Advanced grid management systems for efficiency and reliability."
        },
        {
          id: "energy-analytics",
          name: "Energy Analytics",
          icon: faChartBar,
          shortDescription: "Data-driven insights to optimize energy consumption and production."
        },
        {
          id: "renewable-integration",
          name: "Renewable Integration",
          icon: faSun,
          shortDescription: "Solutions to integrate and manage renewable energy sources."
        }
      ]
    },
    {
      category: "Oil & Gas Technology",
      icon: faIndustry,
      path: "/services/oil-gas-technology",
      description: "Digital transformation solutions for the oil and gas industry.",
      services: [
        {
          id: "production-optimization",
          name: "Production Optimization",
          icon: faIndustry,
          shortDescription: "AI-driven systems to maximize extraction efficiency and safety."
        },
        {
          id: "asset-management",
          name: "Asset Management",
          icon: faCogs,
          shortDescription: "Digital twin technology for equipment monitoring and maintenance."
        },
        {
          id: "field-automation",
          name: "Field Automation",
          icon: faRobot, 
          shortDescription: "Automated solutions for field operations and monitoring."
        }
      ]
    }
  ];

  // Combined services array for detailed services section
  const detailedServices = showAllServices 
    ? [...services, ...additionalServices] 
    : services;
  
  // Combined services array for main grid
  const displayedServices = showAllServices 
    ? [...services, ...additionalServices] 
    : services;

  return (
    <div>
      <section className="bg-primary text-white py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-4">Our Services</h1>
              <p className="lead">
                Comprehensive technology solutions designed to transform your business and drive growth. 
                From custom software development to strategic consulting, we've got you covered.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* How We Work */}
      <section className="section-padding bg-light-custom">
        <Container>
          <h2 className="section-title">How We Work</h2>
          <Row className="justify-content-center">
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
                    <h3 className="m-0">1</h3>
                  </div>
                  <Card.Title>Discovery</Card.Title>
                  <Card.Text>
                    We start by understanding your business, challenges, and objectives to identify opportunities for technology to make an impact.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
                    <h3 className="m-0">2</h3>
                  </div>
                  <Card.Title>Planning</Card.Title>
                  <Card.Text>
                    Our team develops a strategic roadmap, defining the architecture, technologies, and methodologies that will best meet your needs.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
                    <h3 className="m-0">3</h3>
                  </div>
                  <Card.Title>Execution</Card.Title>
                  <Card.Text>
                    Using agile methodologies, we design, develop, and deliver solutions with continuous collaboration and iteration.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-4" style={{ width: '80px', height: '80px' }}>
                    <h3 className="m-0">4</h3>
                  </div>
                  <Card.Title>Optimization</Card.Title>
                  <Card.Text>
                    We provide ongoing support, monitoring, and refinement to ensure your solution evolves with your business needs.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Services Cards */}
      <section className="section-padding bg-light-custom">
        <Container>
          <h2 className="section-title">Our Services</h2>
          <Row>
            {displayedServices.map((service, index) => (
              <Col lg={3} md={6} className="mb-4" key={index}>
                <Card className="card-custom h-100 text-center">
                  <Card.Body>
                    <div className="mb-4">
                      <FontAwesomeIcon icon={service.icon} size="3x" className="text-primary" />
                    </div>
                    <Card.Title>{service.category}</Card.Title>
                    <Card.Text>
                      {service.description}
                    </Card.Text>
                    <Link to={service.path} className="btn btn-link text-primary p-0">
                      Learn More <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button 
              onClick={() => setShowAllServices(!showAllServices)} 
              variant="outline-primary"
            >
              {showAllServices ? "Show Less" : "View All Services"}
            </Button>
          </div>
        </Container>
      </section>

      {/* Industries Section */}
      <section className="section-padding">
        <Container>
          <h2 className="section-title">Industries We Serve</h2>
          <Row className="justify-content-center">
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100">
                <Card.Img variant="top" src="/images/energy-industry.jpg" alt="Energy Sector" />
                <Card.Body>
                  <Card.Title>Energy Sector</Card.Title>
                  <Card.Text>
                    Smart grid solutions, energy management systems, and renewable energy technologies.
                  </Card.Text>
                  <Link to="/industries/energy" className="stretched-link"></Link>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100">
                <Card.Img variant="top" src="/images/oil-gas-industry.jpg" alt="Oil & Gas Industry" />
                <Card.Body>
                  <Card.Title>Oil & Gas</Card.Title>
                  <Card.Text>
                    Production optimization, asset management, and exploration technologies.
                  </Card.Text>
                  <Link to="/industries/oil-gas" className="stretched-link"></Link>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100">
                <Card.Img variant="top" src="/images/healthcare-industry.jpg" alt="Healthcare Industry" />
                <Card.Body>
                  <Card.Title>Healthcare</Card.Title>
                  <Card.Text>
                    Patient management systems, telemedicine solutions, and medical data analytics.
                  </Card.Text>
                  <Link to="/industries/healthcare" className="stretched-link"></Link>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <Card className="card-custom h-100">
                <Card.Img variant="top" src="/images/finance-industry.jpg" alt="Finance Industry" />
                <Card.Body>
                  <Card.Title>Finance</Card.Title>
                  <Card.Text>
                    Fintech solutions, payment systems, and blockchain-based financial applications.
                  </Card.Text>
                  <Link to="/industries/finance" className="stretched-link"></Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Case Studies Teaser */}
      <section className="section-padding bg-light-custom">
        <Container>
          <Row className="align-items-center">
            <Col lg={5} className="mb-4 mb-lg-0">
              <h2 className="mb-4">Success Stories</h2>
              <p className="lead mb-4">
                See how we've helped businesses across various industries solve complex challenges and achieve their goals through innovative technology solutions.
              </p>
              <Button as={Link} to="/case-studies" variant="primary">
                View Case Studies
              </Button>
            </Col>
            <Col lg={7}>
              <Row>
                <Col md={6} className="mb-4">
                  <Card className="card-custom h-100">
                    <Card.Body>
                      <Card.Title>Energy Management Platform</Card.Title>
                      <Card.Text>
                        How we helped a leading energy provider reduce operational costs by 30% through an AI-powered management system.
                      </Card.Text>
                      <Link to="/case-studies/energy-management-platform" className="btn btn-link text-primary p-0">
                        Read Case Study <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} className="mb-4">
                  <Card className="card-custom h-100">
                    <Card.Body>
                      <Card.Title>Blockchain Supply Chain</Card.Title>
                      <Card.Text>
                        Implementing blockchain technology to create a transparent and secure supply chain for a global manufacturer.
                      </Card.Text>
                      <Link to="/case-studies/blockchain-supply-chain" className="btn btn-link text-primary p-0">
                        Read Case Study <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Categories - Fixed and Enhanced Section */}
      <section className="section-padding">
        <Container>
          <Row>
            {detailedServices.map((serviceCategory, index) => (
              <Col lg={6} className="mb-5" key={index}>
                <h2 className="mb-4">{serviceCategory.category}</h2>
                <p className="mb-4">{serviceCategory.description}</p>
                
                {serviceCategory.services.map((service, sIndex) => (
                  <Card className="mb-3 border-0 shadow-sm" key={sIndex}>
                    <Card.Body>
                      <Row className="align-items-center">
                        <Col md={3} className="text-center mb-3 mb-md-0">
                          <div className="service-icon">
                            <FontAwesomeIcon 
                              icon={service.icon} 
                              size="3x" 
                              className="text-primary" 
                            />
                          </div>
                        </Col>
                        <Col md={9}>
                          <h5>{service.name}</h5>
                          <p className="mb-2">{service.shortDescription}</p>
                          <Link 
                            to={`/services/${service.id}`} 
                            className="btn btn-link text-primary p-0"
                          >
                            Learn More <FontAwesomeIcon icon={faArrowRight} className="ms-1" />
                          </Link>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section className="py-5 bg-primary text-white">
        <Container className="text-center">
          <h2 className="mb-4">Ready to Transform Your Business?</h2>
          <p className="lead mb-4">
            Let's discuss how our technology solutions can help you achieve your business goals.
          </p>
          <Button as={Link} to="/contact" variant="light" size="lg">
            Get in Touch
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default Servciepage;